export default __webpack_public_path__ + "static/media/arrow_white_right.cd91ca86.svg";